import * as React from "react";

const SvgCompany = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M18.502 17.004h-.342V6.13a.498.498 0 0 0-.498-.498h-6.664V1.498A.498.498 0 0 0 10.5 1H3.338a.498.498 0 0 0-.498.498v15.506h-.342a.498.498 0 0 0 0 .996h16.004a.498.498 0 0 0 0-.996ZM3.836 1.996h6.166V17.004H8.717V13.11a.498.498 0 0 0-.498-.498h-2.6a.498.498 0 0 0-.498.498v3.894H3.836V1.996Zm2.281 15.008v-3.396h1.604v3.396H6.117Zm7.162 0v-3.396h1.604v3.396h-1.604Zm2.6 0V13.11a.498.498 0 0 0-.498-.498h-2.6a.498.498 0 0 0-.498.498v3.894h-1.285V6.628h6.166v10.376h-1.285Z"
			fill="#A8A8A8"
			stroke="#A8A8A8"
			strokeWidth={0.3}
		/>
		<path
			d="M5.62 6.638h2.6a.498.498 0 0 0 .497-.498V3.7a.498.498 0 0 0-.498-.498h-2.6a.498.498 0 0 0-.497.498v2.44c0 .275.223.498.498.498Zm.498-2.44H7.72v1.444H6.118V4.198ZM5.62 11.275h2.6a.498.498 0 0 0 .497-.498v-2.44a.498.498 0 0 0-.498-.499h-2.6a.498.498 0 0 0-.497.498v2.441c0 .275.223.498.498.498Zm.498-2.44H7.72v1.444H6.118V8.834ZM14.098 8h-2.6a.498.498 0 0 0-.498.498v2.44c0 .276.223.499.498.499h2.6a.498.498 0 0 0 .497-.498V8.498A.498.498 0 0 0 14.098 8Zm-.499 2.44h-1.603V8.997H13.6v1.445Z"
			fill="#A8A8A8"
			stroke="#A8A8A8"
			strokeWidth={0.3}
		/>
	</svg>
);
